import {
  ChevronDownIcon,
  ChevronUpIcon,
  PencilIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";
import { IContact } from "../../models/Contact";
import { ContactCombobox } from "../contacts/ContactCombobox";
import SelectInput from "../shared/Inputs/SelectInput";

interface AccountPrimaryContactSectionProps {
  account?: { id: string };
  register: any;
  setValue: any;
  watch: any;
  primaryContactOptions: { id: string; name: string }[];
  primaryContact?: IContact;
  setPrimaryContact: (contact: IContact) => void;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  onAddContact: () => void;
  onEditContact: () => void;
}

export function AccountPrimaryContactSection({
  account,
  register,
  setValue,
  watch,
  primaryContactOptions,
  primaryContact,
  setPrimaryContact,
  isOpen,
  setIsOpen,
  onAddContact,
  onEditContact,
}: AccountPrimaryContactSectionProps) {
  return (
    <div className="rounded-md border border-gray-200 bg-gray-50/70 p-3">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between text-left"
        aria-label={isOpen ? "Collapse primary contact section" : "Expand primary contact section"}
      >
        <div>
          <p className="text-sm font-semibold text-gray-800">Primary Contact</p>
          <p className="text-xs text-gray-500">Choose, add, or edit the contact</p>
        </div>
        {isOpen ? (
          <ChevronUpIcon className="h-5 w-5 text-gray-500" />
        ) : (
          <ChevronDownIcon className="h-5 w-5 text-gray-500" />
        )}
      </button>
      {isOpen && (
        <div className="mt-3 space-y-2.5">
          {account && (
            <SelectInput
              label="Select from account contacts"
              register={register}
              registerName="primaryContactId"
              setValue={setValue}
              watch={watch}
              options={primaryContactOptions}
              rounded
            />
          )}
          <div className="flex items-end gap-2">
            <div className="flex-1">
              <ContactCombobox
                onContactSelect={(contact) => {
                  setPrimaryContact(contact);
                  setValue("primaryContactId", contact.id);
                }}
                label="Lookup Contact (search)"
                rounded
              />
            </div>
            <button
              type="button"
              onClick={onAddContact}
              className="h-[38px] w-10 inline-flex items-center justify-center rounded-md border border-gray-300 bg-gray-100 px-2 text-gray-600 hover:bg-gray-200"
              aria-label="Add contact"
            >
              <PlusIcon className="h-5 w-5" />
            </button>
          </div>
          {primaryContact && (
            <div className="rounded-md border border-gray-200 bg-white p-2 text-sm">
              <div className="flex items-center justify-between">
                <p className="font-semibold text-gray-800">{primaryContact.fullname}</p>
                <button
                  type="button"
                  onClick={onEditContact}
                  className="inline-flex h-8 w-8 items-center justify-center text-gray-500 hover:text-gray-800 transition-colors"
                  aria-label="Edit selected contact"
                >
                  <PencilIcon className="h-5 w-5" />
                </button>
              </div>
              <p className="text-gray-600 text-xs">{primaryContact.email || "N/A"}</p>
              <p className="text-gray-600 text-xs">{primaryContact.telephone1 || "N/A"}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

